
class MainMenu {
  private mainMenu: HTMLElement | null = document.querySelector('.main-menu');
  private linkForSublist: HTMLElement | null = document.querySelector('.main-menu__link--sublist');
  private sublist: HTMLElement | null = document.querySelector('.main-menu__sublist');
  private sublistCopy: HTMLElement | null = null
  private header: HTMLElement | null = document.querySelector('.header');
  private hamburger: HTMLElement | null = document.querySelector('.main-menu__hamburger');
  private isMobileDevice: boolean = false;
  private mouseIsOverSublistCopy: boolean = false;
  private mouseIsOverLinkForSublist: boolean = false;
  private scrollPosition: number = 0;

  constructor() {
    this.isMobileDevice = window.innerWidth <= 1024;

    this.init()
  }

  checkIsMobileDevice() {
    this.isMobileDevice = window.innerWidth <= 1024;
  }

  cutSublistFromMainMenu() {
    if(this.sublist) {
      this.header?.appendChild(this.sublist);
      this.mainMenu?.querySelector('.main-menu__sublist')?.remove();
    }
  }
  returnSublistToMainMenu() {
    if(this.sublist) {
      this.mainMenu?.appendChild(this.sublist);
      this.header?.querySelector('.main-menu__sublist')?.remove();
    }
  }

  makeCopyOfSublistOutsideMainMenu() {
    if(this.sublist) {
      this.sublistCopy = this.sublist.cloneNode(true) as HTMLElement;
      this.sublistCopy.classList.add('main-menu__sublist--hidden');
      this.sublistCopy.classList.add('main-menu__sublist--copy');
      this.header?.appendChild(this.sublistCopy);
    }
  }

  addEventListeners() {
    if(this.hamburger) {
      this.hamburger.addEventListener('click', () => {
        this.toggleHamburger();
      });
    }
    // if(this.header) {
    //   this.header.addEventListener('mouseenter', (e: MouseEvent) => {
    //     this.mouseIsOverLinkForSublist = true;
    //     this.checkAndShowSublist();
    //   });
    //   this.header.addEventListener('mouseleave', () => {
    //     this.mouseIsOverLinkForSublist = false;
    //     setTimeout(() => {
    //       this.checkAndShowSublist();
    //     }, 100);
    //   });
    // }
    if(this.sublistCopy) {
      this.sublistCopy.addEventListener('mouseenter', () => {
        this.mouseIsOverSublistCopy = true;
        this.checkAndShowSublist();
      });
      this.sublistCopy.addEventListener('mouseleave', () => {
        this.mouseIsOverSublistCopy = false;
        setTimeout(() => {
            this.checkAndShowSublist();
        }, 100);
      });
    }
    if(this.linkForSublist) {
      this.linkForSublist.addEventListener('mouseenter', (e: MouseEvent)=>{
        this.mouseIsOverLinkForSublist = true;
        this.checkAndShowSublist();
      })
      this.linkForSublist.addEventListener('mouseleave', (e: MouseEvent)=>{
        this.mouseIsOverLinkForSublist = false;
        setTimeout(() => {
          this.checkAndShowSublist();
        }, 500);
      })
      this.linkForSublist.addEventListener('click', () => {
        if(this.linkForSublist){
          this.linkForSublist.classList.toggle('main-menu__link--sublist--active');
        }
      });
    }
    Array.from(document.querySelectorAll('.main-menu__link')).forEach((link) => {
      link.addEventListener('click', () => {
        if(!link.classList.contains('main-menu__link--sublist')) {
          this.nonSublistLinkClick();
        }
      });
    });
    window.addEventListener('resize', () => {
      this.checkIsMobileDevice();
      if(!this.isMobileDevice) {
        this.makeCopyOfSublistOutsideMainMenu();
      }
    });
  }

  nonSublistLinkClick() {
    window.popUpOverlay.hide();
    this.hamburger?.classList.remove('main-menu__hamburger--active');
  }

  toggleHamburger() {
    this.checkIsMobileDevice();
    
    if(this.hamburger && this.isMobileDevice) {
      this.hamburger.classList.toggle('main-menu__hamburger--active');
    }
    if(this.hamburger?.classList.contains('main-menu__hamburger--active')) {
      window.popUpOverlay.show();
    } else {
      window.popUpOverlay.hide();
    }
  }

  checkAndShowSublist() {
    this.checkIsMobileDevice();

    if(this.isMobileDevice) {
      this.sublist?.classList.remove('main-menu__sublist--hidden');
      return;
    } else {
      if(this.mouseIsOverLinkForSublist || this.mouseIsOverSublistCopy) {
        this.sublistCopy?.classList.remove('main-menu__sublist--hidden');
        this.sublistCopy?.classList.add('main-menu__sublist--visible');
      } else {
        this.sublistCopy?.classList.remove('main-menu__sublist--visible');
        this.sublistCopy?.classList.add('main-menu__sublist--hidden');
      }
    }
  }

  
  init(){
    this.checkIsMobileDevice();
    if(!this.isMobileDevice) {
      this.makeCopyOfSublistOutsideMainMenu();
    }
    this.addEventListeners();
  }

}

export default function mainmenu() {
  return new MainMenu();
}